const bulletinDetail = {
  path: 'bulletinDetail/:bulletinId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/bulletinDetail'], resolve)
}
export default bulletinDetail
